module.exports = __webpack_public_path__ + "static/media/icon_anim_data_ul100.8d07d521.svg";